export const SET_USER = 'auth/SET_USER'
export const LOGOFF = 'auth/LOGOFF'

const INITIAL_STATE = { user: null }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER:
            return { ...state, user: action.payload }
        case LOGOFF:
            return { ...state, ...INITIAL_STATE }
        default:
            return state
    }
}

export const setUser = payload => ({ type: SET_USER, payload })
export const logoff = () => ({ type: LOGOFF })



// WEBPACK FOOTER //
// ./src/ducks/Auth.js